<script setup lang="ts">
import ListHeader from '@/components/AuditLog/ListHeader.vue';
import ResizableList from '@/components/ResizableList.vue';
import ListRow from '@/components/AuditLog/ListRow.vue';
import auditLog from '@/types/responses/auditLog';
import i18n from "@/lang/i18n";

const props = defineProps<{
  isLoading: boolean
  isSearchCompleted: boolean
  auditLogs: auditLog[]
}>()
</script>
<template>
  <div class="audit-logs-list mb-2">
    <template v-if="props.isLoading">
      <div class="list-loading">
        <label>
          {{ i18n.global.t('pages.common.list.reading') }}
        </label>
      </div>
    </template>
    <template v-else-if="!props.isSearchCompleted">
      <div class="list-loading">
        <label>
          {{ i18n.global.t('pages.common.list.runFilter') }}
        </label>
      </div>
    </template>
    <ResizableList
      scrollAreaSelector=".list"
    >
      <div class="list list-scrollbar">
        <v-table>
          <ListHeader
          />
          <ListRow
            :isLoading="props.isLoading"
            :auditLogs="props.auditLogs"
            :isSearchCompleted="props.isSearchCompleted"
          />
        </v-table>
      </div>
    </ResizableList>
  </div>
</template>
<style scoped>
.audit-logs-list {
  position: relative;
}
.audit-logs-list .list{
  position: relative;
  min-width: 58vw;
  height: var(--resizable-height, var(--list-default-height));
  overflow: auto;
}
.audit-logs-list table th {
  background-color: #f8f9fa;
  position: sticky;
  top: 0;
}
.audit-logs-list .list .id-column{
  min-width: 2em;
}
.audit-logs-list .list .updated-at-column{
  min-width: 10em;;
}
.checkbox-in-grid {
  padding: 1vm;
  height: inherit !important;
  display: inline-grid !important;
}
.list-loading {
  position: absolute;
  min-width: 58vw;
  height: 100%;
  overflow: auto;
  z-index: 1000;
  background-color: rgba(80,80,80,0.5);
  right: 0;
  left: 0;
}
.list-loading>label {
  font-weight: bold;
  color: white;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateY(-50%) translateX(-50%);
}
</style>
